export default {
  SET_PD_TYPE(state, pdType) {
    state.pdType = pdType
  },
  SET_CLOSE_LEFT_PD(state, value) {
    state.close.left.pd = value
  },
  SET_CLOSE_RIGHT_PD(state, value) {
    state.close.right.pd = value
  },
  SET_FAR_LEFT_PD(state, value) {
    state.far.left.pd = value
  },
  SET_FAR_RIGHT_PD(state, value) {
    state.far.right.pd = value
  },
  RESET_PD_DATA(state, data) {
    if (!data || typeof data !== 'object') {
      return
    }

    const hasRightValue =
      (data.close?.right?.pd ?? '') !== '' ||
      (data.far?.right?.pd ?? '') !== ''
    state.pdType = hasRightValue ? 'two' : 'one'
    state.close.left.pd = data.close?.left?.pd ?? data.close?.pd ?? ''
    state.far.left.pd = data.far?.left?.pd ?? data.far?.pd ?? ''

    if (hasRightValue) {
      state.close.right.pd = data.close?.right?.pd ?? ''
      state.far.right.pd = data.far?.right?.pd ?? ''
    } else {
      state.close.right.pd = ''
      state.far.right.pd = ''
    }
  },
  SET_CURRENT_STEP(state, step) {
    state.currentStep = step
  },
  SET_SELECTION(state, {key, value}) {
    if (state.selections[key] === value) return
    state.selections = {...state.selections, [key]: value}
  },
  DELETE_SELECTION(state, key) {
    const newSelections = {...state.selections}
    delete newSelections[key]
    state.selections = newSelections
  },
  SET_QUANTITY(state, quantity) {
    state.quantity = quantity
  },
  SET_ROW_ID(state, id) {
    state.rowId = id
  },
  SET_PRESCRIPTION_DATA(state, data) {
    state.prescriptionData = data
  },
  SET_PRESCRIPTION_DATA_SUBMITTED(state, submitted) {
    state.prescriptionDataSubmitted = submitted
  },
  SET_INITIAL_DATA(state, data) {
    state.initialData = data
  },
  SET_IS_ADVANCING(state, advancing) {
    state.isAdvancing = advancing
  },
  SET_IS_GOING_BACK(state, goingBack) {
    state.isGoingBack = goingBack
  },
  SET_PRICING_LEVEL(state, level) {
    state.pricingLevel = level
  },
  RESET_SELECTIONS_AFTER_STEP(state, step) {
    const keys = Object.keys(state.selections)
    const keysToDelete = keys.filter(key => {
      const stepIndex = state.steps ? state.steps.indexOf(key) : -1
      const targetStepIndex = state.steps ? state.steps.indexOf(step) : -1
      return stepIndex > targetStepIndex
    })

    keysToDelete.forEach(key => {
      const newSelections = {...state.selections}
      delete newSelections[key]
      state.selections = newSelections
    })
  },
  SET_PRICES(state, prices) {
    state.prices = prices
  },
  UPDATE_PRICE(state, {key, value}) {
    state.prices = {...state.prices, [key]: value}
  },
  SET_CSV(state, csv) {
    state.csv = csv
  },
  SET_PRODUCT_DATA(state, productData) {
    state.productData = productData
  },
  SET_PD_DATA(state, pdData) {
    state.pdData = pdData
  },
  SET_ADDITION(state, value) {
    state.addition = value
  },
  SET_STEPS(state, steps) {
    state.steps = steps
  }
}
